import { type UserLite } from '../../resources/User/types';
import { type HttpClient } from '../useHttpClient';

export const getUserByInternalId =
  (httpClient: HttpClient) => async (internalId: string) => {
    const response = await httpClient.api(
      `/admin/users/getByInternalId/${internalId}`,
      {
        method: 'GET',
      }
    );

    return response.body ? (response.json as UserLite) : undefined;
  };
